import { useGetAllSIVChecklistsMutation } from 'src/services/SivChecklist';

export const useSivCheckListView = () => {
  const [
    getAllSIVChecklists,
    {
      data: getAllsivChecklistData,
      error: getAllsivChecklistError,
      isError: getAllsivChecklistIsError,
      isLoading: getAllsivChecklistIsLoading,
      isSuccess: getAllsivChecklistIsSuccess
    }
  ] = useGetAllSIVChecklistsMutation();

  return {
    getAllsivChecklistData,
    getAllsivChecklistError,
    getAllsivChecklistIsError,
    getAllsivChecklistIsLoading,
    getAllsivChecklistIsSuccess,
    getAllSIVChecklists
  };
};
